// Load configuration from JSON file
import awsConfigJson from './aws-config.json';

// Amplify v6 Configuration
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: awsConfigJson.aws_user_pools_id || import.meta.env.VITE_USER_POOL_ID || import.meta.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: awsConfigJson.aws_user_pools_web_client_id || import.meta.env.VITE_USER_POOL_CLIENT_ID || import.meta.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: awsConfigJson.aws_cognito_region || import.meta.env.VITE_REGION || import.meta.env.REACT_APP_REGION || 'us-east-2',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: true,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    }
  },
  Storage: {
    S3: {
      bucket: 'calisthenics-event-images-571340586587',
      region: awsConfigJson.aws_project_region || import.meta.env.VITE_REGION || import.meta.env.REACT_APP_REGION || 'us-east-2',
    }
  },
  API: {
    REST: {
      CalisthenicsAPI: {
        endpoint: awsConfigJson.aws_cloud_logic_custom?.[0]?.endpoint || import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || '',
        region: awsConfigJson.aws_cloud_logic_custom?.[0]?.region || import.meta.env.VITE_REGION || import.meta.env.REACT_APP_REGION || 'us-east-2'
      }
    }
  }
};

export default amplifyConfig;
